import { createFileRoute } from '@tanstack/react-router'

import { Breadcrumbs } from '@/components/layout/breadcrumbs.tsx'
import { LoadingSpinner } from '@/components/spinner/loading-spinner.tsx'
import { useGetAttributeGroup } from '@/features/attribute-groups/hooks/use-get-attribute-group.ts'
import { AttributeGroupForm } from '@/routes/_authenticated/settings/attribute-groups/-components/form.tsx'

export const Route = createFileRoute(
  '/_authenticated/settings/attribute-groups/edit/$attributeGroupId'
)({
  component: AttributeGroupEdit,
})

function AttributeGroupEdit() {
  const { attributeGroupId } = Route.useParams()

  const getAttributeGroupQuery = useGetAttributeGroup({ attributeGroupId })
  const attributeGroup = getAttributeGroupQuery.data?.success
    ? getAttributeGroupQuery.data?.data
    : undefined

  const handleSubmitted = () => getAttributeGroupQuery.refetch()

  return (
    <>
      <Breadcrumbs
        items={[
          { name: 'Impostazioni' },
          {
            name: 'Gruppi Attributi',
            to: `/settings/attribute-groups`,
          },
          {
            name: attributeGroup?.name || attributeGroupId,
          },
        ]}
      />

      {getAttributeGroupQuery.isPending && (
        <div className="py-10">
          <LoadingSpinner />
        </div>
      )}

      {!getAttributeGroupQuery.isPending && (
        <AttributeGroupForm
          attributeGroupId={attributeGroupId}
          attributeGroup={attributeGroup}
          onSubmitted={handleSubmitted}
        />
      )}
    </>
  )
}
